module.exports = __webpack_public_path__ + "fonts/noto-sans-kr-all-400-normal.77288f8.woff";